import React, {Component} from 'react'
import Video from '../../../../../components/Videos/Video'
import { FullVideoContainerStyle } from '../../../../../styles'
import { Triangle } from '../../../../../components/Shapes'

export default class SingleVideoTemplate extends Component {
  state = {
    active: false,
  }

  componentDidMount() {
    this.scaleVideo()
  }

  handlerClick = (e) => {
    e.preventDefault()

    this.setState({
      url: this.props.fields.type === 'vimeo' ? `https://player.vimeo.com/video/${this.props.fields.link}?muted=1&autoplay=1` : `https://www.youtube.com/embed/${this.props.fields.link}?autoplay=1` }, () => {
      this.setState({ active: true })
      document.querySelector('.video-wrapper').scrollTop = 0
      document.querySelector('.video-wrapper').style.overflow = 'hidden'
    })
  }

  handlerClose = (e) => {
    e.preventDefault()
    this.setState({ active: false}, () => {
      this.setState({ url: '' })
      document.querySelector('.video-wrapper').style.overflow = 'auto'
      
    })
  }

  scaleVideo = () => {
    const windowHeight = window.innerHeight
    const videoHeight = this.video
	  const scale = windowHeight / videoHeight
  
    if (videoHeight <= windowHeight) {
      this.video.style.transform = `scale(${scale}) translateY(-50%)`
    }
  }

  render() {
    const { title, picture, picture_position } = this.props
    return (
      <div className={`product-template product-template--video`}>
        <div className={`video-container ${FullVideoContainerStyle(picture, this.state.active, picture_position ? picture_position : 'center' )}`}>
          <div className="video" onClick={this.handlerClick}>
            <button className="btn btn--play">
              <Triangle width={12} height={12} />
            </button>
          </div>
          <span className="video-label">{ title }</span>
          <div className="video-container-full">
            <button className="video-close" onClick={this.handlerClose}>
              <span></span>
              <span></span>
            </button>
            <div className="video-iframe" ref={(video) => this.video = video}>
              <div className="video-wrapper">
                <iframe src={this.state.url} frameBorder="0" allowFullScreen title={ title }></iframe> 
              </div>
            </div>
          </div>  
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/SingleVideoTemplate.js